import { render, staticRenderFns } from "./PickListTest.vue?vue&type=template&id=67ad087b&scoped=true&"
import script from "./PickListTest.vue?vue&type=script&lang=js&"
export * from "./PickListTest.vue?vue&type=script&lang=js&"
import style0 from "./PickListTest.vue?vue&type=style&index=0&id=67ad087b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad087b",
  null
  
)

export default component.exports